var scope_0 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3dcffa9d6b0c416f24c59a90eb4621e0.js').default;
var scope_1 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e90145690fe7f1d2aa25c161889c3ca.js').default;
var scope_2 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a4ffa6bbe51f1bd034c4f27cf49aaa8c.js').default;
var scope_3 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd78329f71c2cb60a9deb8a09dcb04ed.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    